import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _typeof from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/typeof";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import cloneDeep from 'lodash/cloneDeep';
import { FIB } from '@/config/constants';
import { get } from 'vuex-pathify';
import debounce from 'lodash/debounce';
import MenuInsightEpos from "./MenuInsightEpos";
import MenuInsightFamilyGroup from "./MenuInsightFamilyGroup";
import MenuInsightMajorGroup from "./MenuInsightMajorGroup";
import MenuInsightType from "./MenuInsightType";
import getEposDishes from "./menuInsightHelpers/getEposDishes";
import getFamilyGroupDishes from "./menuInsightHelpers/getFamilyGroupDishes";
import getMajorGroupDishes from "./menuInsightHelpers/getMajorGroupDishes";
import { getTypeDishes } from "./menuInsightHelpers/getTypeDishes";
import getFlatDishes from "./menuInsightHelpers/getFlatDishes";
var MENU_INSIGHT_MODE = FIB.MENU_INSIGHT_MODE;
export default {
  name: 'FibMenuInsightQuestion',
  components: {
    'menu-insight-epos': MenuInsightEpos,
    'menu-insight-family-group': MenuInsightFamilyGroup,
    'menu-insight-major-group': MenuInsightMajorGroup,
    'menu-insight-type': MenuInsightType
  },
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      activeCategoryRef: '',
      activeSubcategoryRef: '',
      previousCategoryRef: '',
      previousSubcategoryRef: '',
      filteredProducts: []
    };
  },
  computed: {
    // loading bools
    // ********************************
    allProductsLoading: function allProductsLoading() {
      return this.$store.getters['products/getAllProductsLoading'](this.question);
    },
    categoriesLoading: function categoriesLoading() {
      // check mode and handle based on mode
      var mode = this.mode;

      if (this.transactionDataAvailable) {
        return this.productsByTransactionLoading;
      }

      if (mode === MENU_INSIGHT_MODE.TYPE) {
        return this.familyGroupsByTypeLoading;
      } else if (mode === MENU_INSIGHT_MODE.FAMILY_GROUP) {
        return this.familyGroupsLoading || this.majorGroupsByFamilyGroupLoading;
      } else if (mode === MENU_INSIGHT_MODE.MAJOR_GROUP) {
        return false;
      }

      return false;
    },
    familyGroupsLoading: function familyGroupsLoading() {
      return this.$store.getters['products/getFamilyGroupsLoading'](this.question);
    },
    familyGroupsByTypeLoading: function familyGroupsByTypeLoading() {
      return this.$store.getters['products/getFamilyGroupsByTypeLoading'](this.question);
    },
    majorGroupsLoading: function majorGroupsLoading() {
      return this.$store.getters['products/getMajorGroupsLoading'](this.question);
    },
    majorGroupsByFamilyGroupLoading: function majorGroupsByFamilyGroupLoading() {
      return this.$store.getters['products/getMajorGroupsByFamilyGroupLoading'](this.question);
    },
    majorGroupsByFamilyGroupAndTypeLoading: function majorGroupsByFamilyGroupAndTypeLoading() {
      return this.$store.getters['products/getMajorGroupsByFamilyGroupAndTypeLoading'](this.question);
    },
    productsByFamilyGroupLoading: function productsByFamilyGroupLoading() {
      return this.$store.getters['products/getProductsByFamilyGroupLoading'](this.question);
    },
    productsByMajorGroupLoading: function productsByMajorGroupLoading() {
      return this.$store.getters['products/getProductsByMajorGroupLoading'](this.question);
    },
    productsByTransactionLoading: function productsByTransactionLoading() {
      return this.$store.getters['products/getProductsByTransactionLoading'](this.question);
    },
    productsByTypeLoading: function productsByTypeLoading() {
      return this.$store.getters['products/getProductsByTypeLoading'](this.question);
    },
    productsLoading: function productsLoading() {
      // check mode and handle based on mode
      var mode = this.mode;

      if (this.transactionDataAvailable) {
        return this.productsByTransactionLoading;
      } else if (mode === MENU_INSIGHT_MODE.TYPE) {
        return this.productsByTypeLoading;
      } else if (mode === MENU_INSIGHT_MODE.FAMILY_GROUP) {
        return this.productsByFamilyGroupLoading;
      } else if (mode === MENU_INSIGHT_MODE.MAJOR_GROUP) {
        return this.productsByMajorGroupLoading;
      }

      return false;
    },
    searchResultsLoading: function searchResultsLoading() {
      return this.$store.getters['products/getSearchResultsLoading'](this.question);
    },
    subcategoriesLoading: function subcategoriesLoading() {
      // check mode and handle based on mode
      var mode = this.mode;

      if (this.transactionDataAvailable) {
        return this.productsByTransactionLoading;
      } else if (mode === MENU_INSIGHT_MODE.TYPE) {
        return this.majorGroupsByFamilyGroupAndTypeLoading;
      } else if (mode === MENU_INSIGHT_MODE.FAMILY_GROUP) {
        return false;
      } else if (mode === MENU_INSIGHT_MODE.MAJOR_GROUP) {
        return false;
      }

      return false;
    },
    topLevelLoading: function topLevelLoading() {
      // check mode and handle based on mode
      var mode = this.mode;

      if (this.transactionDataAvailable) {
        return this.productsByTransactionLoading;
      } else if (mode === MENU_INSIGHT_MODE.TYPE) {
        return this.categoriesLoading;
      } else if (mode === MENU_INSIGHT_MODE.FAMILY_GROUP) {
        return this.categoriesLoading;
      } else if (mode === MENU_INSIGHT_MODE.MAJOR_GROUP) {
        return this.productsLoading || this.majorGroupsLoading;
      }

      return false;
    },
    // group details // *********************************
    familyGroups: get('products/familyGroups'),
    familyGroupsByType: get('products/familyGroupsByType'),
    majorGroups: get('products/majorGroups'),
    majorGroupsByFamilyGroup: get('products/majorGroupsByFamilyGroup'),
    majorGroupsByFamilyGroupAndType: get('products/majorGroupsByFamilyGroupAndType'),
    types: get('products/types'),
    // product data // **********************************
    allProducts: get('products/allProducts'),
    eposData: get('checkIn/eposData'),
    productSearchResults: get('products/productSearchResults'),
    productsByFamilyGroup: get('products/productsByFamilyGroup'),
    productsByMajorGroup: get('products/productsByMajorGroup'),
    productsByTransaction: get('products/productsByTransaction'),
    productsByType: get('products/productsByType'),
    // local computed properties // *********************
    activeCategory: function activeCategory() {
      var _this = this;

      return this.dishes.find(function (d) {
        return d.ref === _this.activeCategoryRef;
      }) || {};
    },
    activeSubcategory: function activeSubcategory() {
      var _this2 = this;

      var categoryOptions = this.activeCategory ? this.activeCategory.options : null;

      if (Array.isArray(categoryOptions)) {
        var activeSubcategory = categoryOptions.find(function (o) {
          return o.ref === _this2.activeSubcategoryRef;
        });
        return activeSubcategory || {};
      } else {
        return {};
      }
    },
    dishes: function dishes() {
      // if transaction data available, return epos dishes, else, return manual dishes
      return this.transactionDataAvailable ? this.eposDishes : this.manualDishes;
    },
    eposDishes: function eposDishes() {
      var _this3 = this;

      var products = []; // if App, create products in the correct format based off of received transaction data

      if (this.isApp) {
        products = this.transactionData.filter(function (prod) {
          return prod.type === _this3.question.menuType;
        }).map(function (prod) {
          return {
            familyGroupName: prod.familyGroupName,
            familyGroupRef: prod.familyGroupId,
            majorGroupName: prod.majorGroupName,
            majorGroupRef: prod.majorGroupId,
            name: prod.menuItemName,
            ref: prod.menuItemObjectNumber,
            type: prod.type
          };
        });
      } else {
        var _this$productsByTrans;

        // if not App get products from store
        products = (_this$productsByTrans = this.productsByTransaction) === null || _this$productsByTrans === void 0 ? void 0 : _this$productsByTrans[this.question.id]; // if no products, return empty array

        if (!products) {
          return [];
        }
      }

      var payload = {
        question: this.question,
        products: products
      };
      return getEposDishes(payload);
    },
    transactionData: function transactionData() {
      return this.$store.getters['checkIn/transactionProducts']();
    },
    transactionProductRefs: function transactionProductRefs() {
      return Array.isArray(this.transactionData) ? this.transactionData.map(function (m) {
        return m.menuItemObjectNumber;
      }) : [];
    },
    transactionDataAvailable: function transactionDataAvailable() {
      var _this$transactionData;

      return !!((_this$transactionData = this.transactionData) !== null && _this$transactionData !== void 0 && _this$transactionData.length);
    },
    manualDishes: function manualDishes() {
      var _this$question;

      var mode = this.mode;
      var payload = {
        question: this.question,
        mode: mode,
        familyGroups: this.familyGroups,
        familyGroupsByType: this.familyGroupsByType,
        majorGroups: this.majorGroups,
        majorGroupsByFamilyGroup: this.majorGroupsByFamilyGroup,
        majorGroupsByFamilyGroupAndType: this.majorGroupsByFamilyGroupAndType,
        type: (_this$question = this.question) === null || _this$question === void 0 ? void 0 : _this$question.menuType
      }; // detect mode and handle if mode supported

      if (mode === MENU_INSIGHT_MODE.TYPE) {
        if (this.isApp) {
          payload.products = _defineProperty({}, payload.type, this.productsByType[payload.type]);
        } else {
          payload.products = this.productsByType;
        }

        return getTypeDishes(payload);
      } else if (mode === MENU_INSIGHT_MODE.FAMILY_GROUP) {
        payload.products = this.productsByFamilyGroup;
        return getFamilyGroupDishes(payload);
      } else if (mode === MENU_INSIGHT_MODE.MAJOR_GROUP) {
        payload.products = this.productsByMajorGroup;
        return getMajorGroupDishes(payload);
      } // if mode not supported, return empty array


      return [];
    },
    getSearchResultDishes: function getSearchResultDishes() {
      return getFlatDishes(this.question, this.mode, this.isApp ? this.filteredProducts : this.productSearchResults[this.question.id] || []);
    },
    allProductsAsInlineDishes: function allProductsAsInlineDishes() {
      var products = [];

      if (this.isApp) {
        this.allProducts.forEach(function (famGroup) {
          famGroup.majorGroups.forEach(function (mg) {
            mg.products.forEach(function (prod) {
              products.push(prod);
            });
          });
        });
      } else {
        products = this.allProducts;
      }

      return getFlatDishes(this.question, this.mode, products);
    },
    mode: function mode() {
      return this.question ? this.question.mode : MENU_INSIGHT_MODE.TYPE; // defaulting to mode 'type'
    },
    questionType: function questionType() {
      // if epos available - return question based on EPOS data
      if (this.transactionDataAvailable) {
        return 'menu-insight-epos';
      } // return based on question type


      var component = null;

      switch (this.mode) {
        case MENU_INSIGHT_MODE.TYPE:
          component = 'menu-insight-type';
          break;

        case MENU_INSIGHT_MODE.FAMILY_GROUP:
          component = 'menu-insight-family-group';
          break;

        case MENU_INSIGHT_MODE.MAJOR_GROUP:
          component = 'menu-insight-major-group';
          break;
      }

      return component;
    },
    answers: function answers() {
      return this.$store.getters['answers/responses'] || {};
    },
    response: function response() {
      return this.answers["question".concat(this.question.id)] || [];
    },
    isApp: get('config/isApp')
  },
  created: function created() {
    // only handle setup if not app
    if (this.isApp) {
      return;
    } // if transaction data available, get that, else, check mode and handle setup based on mode


    var mode = this.mode;

    if (this.transactionDataAvailable) {
      this.eposSetup();
    } else if (mode === MENU_INSIGHT_MODE.TYPE) {
      this.typeSetup();
    } else if (mode === MENU_INSIGHT_MODE.FAMILY_GROUP) {
      this.familyGroupSetup();
    } else if (mode === MENU_INSIGHT_MODE.MAJOR_GROUP) {
      this.majorGroupSetup();
    }
  },
  methods: {
    onCategorySelected: function onCategorySelected(category) {
      // check if the category has changed, if not, do nothing, else, handle category changed
      var changed = category.ref !== this.activeCategoryRef; // always update previous and current category

      this.previousCategoryRef = this.activeCategory.ref || '';
      this.activeCategoryRef = category.ref;

      if (changed) {
        this.onCategoryChange();
      }
    },
    onCategoryChange: function onCategoryChange() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var subcategory, _subcategory;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this4.mode === MENU_INSIGHT_MODE.TYPE)) {
                  _context.next = 8;
                  break;
                }

                if (_this4.isApp) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return _this4.$store.dispatch('products/fetchMajorGroupsByFamilyGroupAndType', {
                  familyGroup: _this4.activeCategory,
                  question: _this4.question
                });

              case 4:
                // set subcategory to the current families first option
                // const activeCategory = lodash.cloneDeep(this.activeCategory); // Not used
                subcategory = _this4.activeCategory && _this4.activeCategory.options && _this4.activeCategory.options[0] ? _this4.activeCategory.options[0] : {};

                _this4.onSubcategorySelected(subcategory, true);

                _context.next = 9;
                break;

              case 8:
                if (_this4.mode === MENU_INSIGHT_MODE.FAMILY_GROUP) {
                  // handle for FAMILY GROUP mode
                  // set subcategory to the current families first option
                  // const activeCategory = lodash.cloneDeep(this.activeCategory); // Not used
                  _subcategory = _this4.activeCategory && _this4.activeCategory.options && _this4.activeCategory.options[0] ? _this4.activeCategory.options[0] : {};

                  _this4.onSubcategorySelected(_subcategory, true);
                } else if (_this4.mode === MENU_INSIGHT_MODE.MAJOR_GROUP) {// handle for MAJOR GROUP mode
                  // This shouldn't happen based on current design, so do nothing
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onSubcategorySelected: function onSubcategorySelected(subcategory) {
      var categoryChanged = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // check if the sub category has changed
      var changed = this.subcategoryChanged(subcategory); // always update previous and current subcategory

      this.previousSubcategoryRef = this.activeSubcategory.ref || '';
      this.activeSubcategoryRef = subcategory.ref; // if either category or subcategory changed, handle subcategory changed, else, do nothing

      if (changed || categoryChanged) {
        this.onSubcategoryChange();
      }
    },
    subcategoryChanged: function subcategoryChanged(subcategory) {
      return subcategory && subcategory.ref && subcategory.ref !== this.activeSubcategoryRef;
    },
    onSubcategoryChange: function onSubcategoryChange() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var question, majorGroup, familyGroup;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this5.mode === MENU_INSIGHT_MODE.TYPE)) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return _this5.fetchProductsByType();

              case 3:
                _context2.next = 14;
                break;

              case 5:
                if (!(_this5.mode === MENU_INSIGHT_MODE.FAMILY_GROUP)) {
                  _context2.next = 13;
                  break;
                }

                // handle for FAMILY GROUP mode
                question = cloneDeep(_this5.question);
                majorGroup = cloneDeep(_this5.activeCategory);
                familyGroup = cloneDeep(_this5.familyGroups.find(function (f) {
                  return f.ref === question.menuFamilyGroupRef;
                }));
                _context2.next = 11;
                return _this5.fetchProductsByFamilyGroup({
                  familyGroup: familyGroup,
                  majorGroup: majorGroup,
                  question: question
                });

              case 11:
                _context2.next = 14;
                break;

              case 13:
                if (_this5.mode === MENU_INSIGHT_MODE.MAJOR_GROUP) {// handle for MAJOR GROUP mode
                  // This shouldn't happen based on current design, so do nothing
                }

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    fetchProductsByType: function fetchProductsByType() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var payload;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this6.isApp) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                // fetch products by type
                payload = {
                  familyGroup: _this6.activeCategory,
                  majorGroup: _this6.activeSubcategory,
                  question: _this6.question
                };
                _context3.next = 5;
                return _this6.$store.dispatch('products/fetchProductsByType', payload);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    fetchProductsByFamilyGroup: function fetchProductsByFamilyGroup(payload) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this7.$store.dispatch('products/fetchProductsByFamilyGroup', payload);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onInput: function onInput(rating) {
      // if rating missing, ditch out
      if (!rating) {
        return;
      }

      var question = this.question; // upsert to store (needs upsert function, not answers/setResponse)

      this.$store.dispatch('answers/upsertMenuInsightResponse', {
        question: question,
        rating: rating
      });
    },
    onClear: function onClear(id) {
      // if id missing, ditch out
      if (!id) {
        return;
      }

      var question = this.question; // dispatch clear to store

      this.$store.dispatch('answers/clearMenuInsightResponse', {
        question: question,
        id: id
      });
    },
    onSearch: debounce(function (value) {
      var _this8 = this;

      if (value && value.length >= 3) {
        if (!this.isApp) {
          // po value in search waiting room
          this.$store.commit('products/setSearchWaitingRoom', {
            question: this.question,
            value: value
          }); // fetch search results via store

          this.$store.dispatch('products/fetchProductsBySearchResults', {
            question: this.question,
            mode: this.mode
          });
        } else {
          var search = (value || '').trim().toLowerCase();
          this.allProducts.forEach(function (famGroup) {
            return _objectSpread(_objectSpread({}, famGroup), {}, {
              majorGroups: famGroup.majorGroups.map(function (mg) {
                return _objectSpread(_objectSpread({}, mg), {}, {
                  products: mg.products.filter(function (product) {
                    var _this8$question;

                    if (((product === null || product === void 0 ? void 0 : product.name) || '').toLowerCase().includes(search) && product.type === ((_this8$question = _this8.question) === null || _this8$question === void 0 ? void 0 : _this8$question.menuType)) {
                      _this8.filteredProducts.push(product);
                    }
                  })
                });
              })
            });
          });
        }
      } else if (!value || value.length < 3) {
        this.clearSearch();
      }
    }, 1000),
    clearSearch: function clearSearch() {
      if (this.isApp) {
        this.filteredProducts = [];
      } else {
        this.$store.commit('products/setSearchWaitingRoom', {
          question: this.question,
          value: null
        });
        this.$store.commit('products/setProductSearchResults', {
          question: this.question,
          products: []
        });
      }

      this.$store.commit('products/setSearchResultsLoading', {
        question: this.question,
        isLoading: false
      });
    },
    familyGroupSetup: function familyGroupSetup() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this9$majorGroupsByF;

        var findFamily, question, familyGroupRef;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                findFamily = function findFamily(groups, ref) {
                  return groups.find(function (f) {
                    return f.ref === ref;
                  });
                };

                question = _this9.question;
                familyGroupRef = question.menuFamilyGroupRef; // always fetch family group at question setup for type questions

                _context5.next = 5;
                return _this9.$store.dispatch('products/fetchFamilyGroups', {
                  familyGroupRef: familyGroupRef,
                  question: question
                });

              case 5:
                if ((_this9$majorGroupsByF = _this9.majorGroupsByFamilyGroup[familyGroupRef]) !== null && _this9$majorGroupsByF !== void 0 && _this9$majorGroupsByF.length) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 8;
                return _this9.$store.dispatch('products/fetchMajorGroupsByFamilyGroup', {
                  question: question,
                  familyGroup: findFamily(_this9.familyGroups, familyGroupRef)
                });

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    majorGroupSetup: function majorGroupSetup() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var majorGroup;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this10.$store.dispatch('products/fetchMajorGroups', {
                  majorGroupRef: _this10.question.menuMajorGroupRef,
                  question: _this10.question
                });

              case 2:
                if (Array.isArray(_this10.majorGroups)) {
                  _context6.next = 4;
                  break;
                }

                return _context6.abrupt("return");

              case 4:
                majorGroup = _this10.majorGroups.find(function (v) {
                  return v.ref === _this10.question.menuMajorGroupRef;
                }); // fetch products for major group

                _this10.$store.dispatch('products/fetchProductsByMajorGroup', {
                  majorGroup: majorGroup,
                  question: _this10.question,
                  type: _this10.question.menuType
                });

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    eposSetup: function eposSetup() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                // fetch product data for menu items in transaction
                _this11.$store.dispatch('products/fetchProductsByTransaction', {
                  question: _this11.question,
                  transactionData: _this11.transactionData,
                  type: _this11.question.menuType
                });

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    typeSetup: function typeSetup() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this12.$store.dispatch('products/fetchFamilyGroupsByType', {
                  question: _this12.question,
                  type: _this12.question.menuType
                });

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    filterProducts: function filterProducts() {
      var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var filter = arguments.length > 1 ? arguments[1] : undefined;

      if (!filter || !_typeof(filter) === 'function') {
        return products;
      } else {
        return cloneDeep(products).filter(function (v) {
          return filter(v);
        });
      }
    }
  }
};